import { HeadSEO } from "../../components/SEO/HeadSEO";
import EmailSignup from "@/components/EmailSignup";
import * as StyledLayout from "../../layouts/Styled.Layout";
import * as StyledTypography from "../../styles/Styled.Typography";

export default function Newsletter() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Stanley Yeo",
    url: "https://stanleyyeo.com",
  };
  return (
    <>
      <HeadSEO
        siteTitle="Newsletter"
        siteDescription="Join Stanley’s weekly newsletter for designers—actionable tips, freelance lessons, and insights on WordPress and web design. Unsubscribe anytime."
        structuredData={structuredData}
      />
      <StyledTypography.ParadoxSubtitle as="h2" data-animate="fade-up">
        Mostly for designers. Slightly useful for everyone else.
      </StyledTypography.ParadoxSubtitle>
      <StyledLayout.Grid>
        <StyledLayout.GridItem>
          <p data-animate="fade-up">
            Once a week. Two minutes to read. Actionable ideas to help your
            one-man design business win (or at least look productive).
          </p>
          <p data-animate="fade-up">
            Mostly for designers. Occasionally for humans masquerading as
            designers. 100% risk free, unsubscribe anytime.
          </p>
        </StyledLayout.GridItem>
      </StyledLayout.Grid>
    </>
  );
}
